var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8325 8.431C10.8872 8.87431 10.5839 9.28117 10.1439 9.35559L3.45417 10.477C3.00007 10.5532 2.57018 10.2468 2.49402 9.79275C2.41787 9.33866 2.72432 8.90959 3.17841 8.83343L7.99891 8.02396L0.952836 2.52508C0.590498 2.24231 0.525828 1.71795 0.808602 1.35561C1.09138 0.993272 1.61491 0.928703 1.97808 1.21138L8.93217 6.63847L8.3128 1.61652C8.2565 1.15998 8.58132 0.743759 9.03787 0.687453C9.49441 0.631147 9.91063 0.955975 9.96694 1.41252L10.8324 8.43018L10.8325 8.431Z",
    fill: "#C60F0F",
    fillOpacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownIcon);
export default __webpack_public_path__ + "static/media/down-icon.e123b3fa22727c2a30620b175285c18e.svg";
export { ForwardRef as ReactComponent };